<template>
    <iframe id="kanbanFrame" src="//taiga.thirty3.tools/" width="100%"></iframe>
</template>

<script>

export default {
  name: 'KanbanIndex',
  components: {},

  mounted () {
    // eslint-disable-next-line
    $('body').addClass('process')
  },

  updated () {
    // eslint-disable-next-line
    $('body').addClass('process')
  },

  beforeDestroy () {
    // eslint-disable-next-line
    $('body').removeClass('process')
  }
}
</script>

<style>
    .process .page-header .breadcrumb-line.breadcrumb-line-component {
        display: none;
    }
    .process .content {
        padding: 0;
        height: 100%;
    }

    #kanbanFrame {
        display: block;
        position: relative;
        min-height: 900px;
        height: 100%;
    }
</style>
